export default __webpack_public_path__ + "static/media/beverlyKlein.b40d461e.jpg";